export default {
  date: 'Datum',
  chooseExpDate: 'Välj ett datum',
  filterExpDate: 'Filtrera efter datum',
  experienceType: 'Typ',
  filterExperienceType: 'Filtrera efter typ',
  experienceVibe: 'Stämning',
  filterExperienceVibe: 'Filtrera efter stämning',
  search: 'Sök',
  viewCalendar: 'Kalender',
  back: 'Tillbaka',
  previous: 'Föregående',
  next: 'Nästa',
  noExperiences: 'Inga upplevelser',
  cancelChanges: 'Avbryt ändringar',
  saveChanges: 'Spara ändringar',
  removeFromReservation: 'Ta bort från reservation',
  addToCart: 'Lägg i varukorg',
  proceedToCheckout: 'Fortsätt till kassan',
  selectDate: 'Välj datum',
  startDate: 'Startdatum',
  endDate: 'Slutdatum',
  submit: 'Skicka',
  filterExperienceTypeScreenReader:
    'Använd dessa filter för att begränsa resultaten. Innehållet uppdateras automatiskt när ett filter väljs.',
};
